// extracted by mini-css-extract-plugin
module.exports = {"item":"SidebarItem_item__10pA2","open":"SidebarItem_open__wyaoC","active":"SidebarItem_active__clS6X","iconBlock":"SidebarItem_iconBlock__VyRUK","name":"SidebarItem_name__2OJI2"};